<template>
  <div class="admin">
    <DevelopmentBanner />
    <div class="wrapper">
      <div class="frow row-end">
        <router-link to="/profile">{{ user.username }}</router-link>
        &nbsp;
        <div @click="logout">
          <i class="logout fas fa-sign-out-alt"></i>
        </div>
      </div>
      <div class="frow">
        <div class="box">
          <div class="frow gutters">
            <div class="col-md-1-3">
              <nav class="panel">
                <p class="panel-heading">
                  Projects
                </p>
                <a
                  v-for="project in projects"
                  :key="project.id"
                  :class="{'is-active': activeProject.id == project.id}"
                  class="panel-block"
                  @click.prevent="activeProject = project; activeTab = 'projectInfo'"
                >
                  {{ project.name }}
                </a>
              </nav>
              <button @click="showNewProjectModal = true">Add New Project</button>
            </div>
            <div class="col-md-2-3">
              <div v-if="activeProject">
                <h1>{{ activeProject.name }}</h1>
                <div class="tabs">
                  <ul>
                    <li
                      :class="{'is-active': activeTab == 'projectInfo'}"
                      @click="activeTab = 'projectInfo'"
                    >
                      <a>
                        Project Info
                      </a>
                    </li>
                    <li
                      :class="{'is-active': activeTab == 'steps'}"
                      @click="activeTab = 'steps'"
                    >
                      <a>
                        Steps
                      </a>
                    </li>
                    <li
                      v-if="activeProject.interactiveQuotesEnabled"
                      :class="{'is-active': activeTab == 'submittedQuotes'}"
                    >
                      <button
                        type="button"
                        class="submitted-quotes-tab"
                        @click="activeTab = 'submittedQuotes'"
                      >
                        Submitted Quotes
                      </button>
                    </li>
                    <li
                      :class="{'is-active': activeTab == 'deleteProject'}"
                      @click="activeTab = 'deleteProject'"
                    >
                      <a>
                        Delete Project
                      </a>
                    </li>
                  </ul>
                </div>
                <ProjectForm
                  v-if="activeTab == 'projectInfo'"
                  :project="activeProject"
                  @project-saved="handleProjectSaved"
                />
                <ProjectSteps
                  v-if="activeTab == 'steps'"
                  :steps.sync="activeProject.steps"
                  :project="activeProject"
                />
                <ProjectQuoteSubmissions
                  v-if="activeProject.interactiveQuotesEnabled && activeTab == 'submittedQuotes'"
                  :project="activeProject"
                />
                <DeleteProject
                  v-if="activeTab == 'deleteProject'"
                  :project="activeProject"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <NewProjectModal
      v-if="showNewProjectModal"
      @closeModal="closeModal"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import DevelopmentBanner from '@/components/DevelopmentBanner.vue';
import ProjectForm from '@/components/ProjectForm.vue';
import ProjectSteps from '@/components/ProjectSteps.vue';
import ProjectQuoteSubmissions from '@/components/ProjectQuoteSubmissions.vue';
import DeleteProject from '@/components/DeleteProject.vue';
import NewProjectModal from '@/components/NewProjectModal.vue';

export default {
  name: 'admin',
  components: {
    DevelopmentBanner,
    ProjectForm,
    ProjectSteps,
    ProjectQuoteSubmissions,
    DeleteProject,
    NewProjectModal,
  },
  data() {
    return {
      activeProject: null,
      activeTab: 'projectInfo',
      projects: null,
      showNewProjectModal: false,
    };
  },
  computed: {
    ...mapState({
      user: state => state.profile.user,
    }),
    API() {
      return this.$API;
    },
  },
  methods: {
    getProjects() {
      this.axios.get(`${this.$API}/projects?_sort=id:DESC`).then((response) => {
        this.projects = response.data;
        // If activeProject exists, update it from the refreshed list
        if (this.activeProject && this.activeProject.id) {
          const updatedProject = this.projects.find(p => p.id === this.activeProject.id);
          if (updatedProject) {
            this.activeProject = updatedProject;
          } else {
            [this.activeProject] = this.projects;
          }
        } else {
          [this.activeProject] = this.projects;
        }
      });
    },
    handleProjectSaved(updatedProject) {
      // Update the activeProject with the saved data
      Object.assign(this.activeProject, updatedProject);

      // Update the project in the projects list to keep everything in sync
      if (this.projects) {
        const projectIndex = this.projects.findIndex(p => p.id === updatedProject.id);
        if (projectIndex !== -1) {
          // Update the project in the list
          this.$set(this.projects, projectIndex, updatedProject);
        }
      }
    },
    logout() {
      this.$store.commit('logout');
    },
    closeModal() {
      this.getProjects();
      this.showNewProjectModal = false;
    },
  },
  created() {
    if (!this.$store.getters.isLoggedIn) {
      this.$router.push('/login');
    } else {
      this.getProjects();
    }
  },
};
</script>
<style lang="scss" scoped>
.admin {
  background-color: #fff;
  height: 100%;
  overflow-y: auto;
  width: 100%;
}
.wrapper {
  margin: auto;
  // margin-top: 50px;
  width: 90%;
}
.logout {
  cursor: pointer;
}
.box {
  margin-top: 50px;
  width: 100%;
}
form {
  overflow: scroll;
  max-height: 800px;
}

.panel-block {
  &.is-active {
    background: black;
    color: #fff;
  }
}

.submitted-quotes-tab {
  align-items: center;
  background: transparent;
  border: 0;
  border-bottom: 1px solid #dbdbdb;
  color: #4a4a4a;
  cursor: pointer;
  display: flex;
  font: inherit;
  justify-content: center;
  margin-bottom: -1px;
  padding: 0.5em 1em;
  vertical-align: top;
}

.tabs li.is-active .submitted-quotes-tab {
  border-bottom-color: #3273dc;
  color: #3273dc;
}
</style>
